import { Icon, List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTableConfig } from 'modules/Recommendations/Audits/subcomponents/List/useTableConfig'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { SEEN } from 'modules/Recommendations/Audits/store/types'
import EmptyResults from 'components/EmptyResults'

const ListComponent = ({
  data,
  filters,
  checkboxHandleChange,
  checkedIDs,
  processingIds,
  loading,
}) => {
  const breakpoints = useBreakpoint()
  const dispatch = useDispatch()

  const setSeen = useCallback(
    (id = null) =>
      dispatch({
        type: SEEN,
        payload: [id],
      }),
    [],
  )

  const archiveView = useMemo(() => filters.status === 'archived', [filters])

  const [columnVisibility, setColumnVisibility] = useState()

  useEffect(() => {
    if (!breakpoints.md) {
      setColumnVisibility({ is_new: false, view: false })
    } else if (!breakpoints.lg) {
      setColumnVisibility({ is_new: false })
    } else {
      setColumnVisibility({})
    }
  }, [breakpoints, archiveView])

  const { tableState, tableConfig } = useTableConfig(
    {
      archiveView,
      checkboxHandleChange,
      filters,
      setSeen,
      meta: { checkedIDs, processingIds },
    },
    data,
  )

  useEffect(() => {
    tableState.setState((prevState) => ({ ...prevState, columnVisibility }))
  }, [columnVisibility])

  return (
    <List
      table={tableState}
      config={tableConfig}
      loading={loading}
      EmptyComponent={() => <EmptyResults icon={<Icon name={'document'} />} />}
    />
  )
}

ListComponent.propTypes = {
  data: PropTypes.array,
  checkboxHandleChange: PropTypes.func,
  filters: PropTypes.object,
  checkedIDs: PropTypes.array,
  processingIds: PropTypes.array,
  loading: PropTypes.bool,
}

export default ListComponent
